(() => {
  if (window.hkFdagForsideLoaded) return;
  window.hkFdagForsideLoaded = true;
  const timers = new Map();
  function init() {
    document.querySelectorAll('[data-hk-fdag-forside-countdown]').forEach((timer) => {
      if (timers.has(timer)) return;
      const deadline = Date.parse(timer.dataset.end);
      if (!Number.isFinite(deadline)) return;
      const tick = () => {
        const left = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        const values = { days: Math.floor(left / 86400), hours: Math.floor(left % 86400 / 3600), minutes: Math.floor(left % 3600 / 60), seconds: left % 60 };
        Object.entries(values).forEach(([key, value]) => {
          timer.querySelector(`[data-time="${key}"]`).textContent = String(value).padStart(2, '0');
        });
        if (left === 0) {
          timer.querySelector('.hk-fdag-forside__timer-label').textContent = timer.dataset.ended;
          timer.querySelector('[role="timer"]').setAttribute('aria-label', timer.dataset.ended);
          clearInterval(timers.get(timer));
        }
      };
      timers.set(timer, setInterval(tick, 1000));
      tick();
    });
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    timers.forEach((interval, timer) => {
      if (event.target.contains(timer)) { clearInterval(interval); timers.delete(timer); }
    });
  });
  init();
})();
